/* eslint-disable import-x/no-default-export */
import Chance from 'chance';

import resume from './Resume';

const chance = new Chance();

export default () => ({
  resume: () => ({
    createdDateUtc: new Date().toISOString(),
    fileMetadata: {
      ...resume().fileMetadata,
      name: `${chance.first().substr(0, 1)} ${chance.last()} Seek Resumé.docx`,
    },
    origin: {
      type: 'Generated',
    },
    isDefault: false,
  }),
});
